export enum FontStyle {
  REGULAR = '_reg',
  ITALIC = '_em',
  STRONG = '_strong',
  ITALIC_STRONG = '_em_strong',
}
